module.exports = __webpack_public_path__ + "img/quard7.a73f8b47.png";